<template lang="pug">
section.panel.power-bar-panel(:style="{'--height':maxLineHeight}", :id="`power-bar-panel${blockIndex}`")
  div.left
    div.power-bar-line-bg(:id="`power-bar-line-bg${blockIndex}`")
    div.power-bar-line(ref="powerBarLine" ,:id="`power-bar-line${blockIndex}`")
  div.right
    div.description {{ paragraph }}
    div.power-bar-precentage-year
      div.power-bar-precentage 
        div.power-bar-precentage-text {{ firstRowText }}
        div.power-bar-precentage-value {{ getPowerBarPrecentage() }}
      div.power-bar-year 
        div.power-bar-year-text {{ secondRowText }}
        div.power-bar-year-value {{ getPowerBarYear() }}
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

export default {
  components : {
  },

  props : ['blockIndex', 'paragraph', 'firstRowText', 'secondRowText'],

  name: 'power-bar',

  data() {
    return {
      lineBoundHeight:0,
      lineOffsetHeight:0,
      stickyOffsetHeight:0,
    }
  },

  computed : {
    maxLineHeight(){
      return "calc(100vh - "+this.stickyOffsetHeight+"px)";
    },
    powerBarPrecentage(){
      return this.lineBoundHeight > 0 ? Math.ceil((this.lineBoundHeight/this.lineOffsetHeight*100)/5)*5 : this.lineBoundHeight;
    },
    powerBarYear(){
      return this.lineBoundHeight > 0 ? (this.powerBarPrecentage/5+1).toFixed(0).padStart(2, '0') : "01";
    }
  },

  watch : {
  },
  mounted () {
    this.calcPosOfBox()
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
    gsap.from(`#power-bar-line${this.blockIndex}`, {
        scrollTrigger: {
            trigger: `#power-bar-panel${this.blockIndex}`,
            scrub: 0,
            pin: true,
            start: "top+50px top",
            end: "bottom top",
        },
        scaleY: 0, 
        transformOrigin: "bottom top", 
        ease: "circ.outout",
        onUpdate: ()=> {
          this.calcPosOfBox()
        }
    });
  },

  async created() {

  },

  methods : {
    calcPosOfBox () {
      this.lineBoundHeight = this.$refs['powerBarLine'].getBoundingClientRect().height
      this.lineOffsetHeight = this.$refs['powerBarLine'].offsetHeight
      this.stickyOffsetHeight = document.querySelector('.sticky') ? document.querySelector('.sticky').offsetHeight : 0;
    },
    getPowerBarPrecentage() {
        return this.powerBarPrecentage+"% "
    },
    getPowerBarYear() {
        return "20"+this.powerBarYear
    },
  }
}
</script>

<style lang="scss">
@mixin mobile{
    @media(max-width: 768px){
        @content
    }
}
html,
body {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    scroll-behavior: smooth;
}

body {
    overflow-x: hidden;
    overflow-y: scroll;
}

.power-bar-block{
  .pin-spacer{
    margin: 0 !important;
  }
  .panel.power-bar-panel {
    width: 100%;
    --height: 100vh;
    height: var(--height) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    text-align: center;
    color: white;
    position: relative;
    box-sizing: border-box;
    background: #D9D9D9;
    min-height: 100vh;

    .left {
        width: 50%;
        margin: 0 auto;

        .power-bar-line-bg {
            width: 100%;
            max-width: 20px;
            height: 100%;
            position: relative;
            display: inline-block;
            --color: rgba(255, 255, 255, 1);
            background-color: var(--color);
            bottom: 0;
            position: absolute;
        }
        .power-bar-line {
            width: 100%;
            max-width: 20px;
            height: 100%;
            position: relative;
            display: inline-block;
            --color: #32CD32;
            background-color: var(--color);
            bottom: 0;
            position: absolute;
        }
    }

    .right {
        width: 50%;
        margin: auto;
        text-align: left;
        background: #BFBFBF;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .description {
            color: black;
            position: relative;
            margin: 15px;
            font-size: 24px;
            text-align: left;
            @include mobile{
              font-size: 16px;
            }
        }
        .power-bar-precentage-year{
            margin: 15px;
            .power-bar-precentage-text,
            .power-bar-year-text{
              font-size:16px;
            }
            .power-bar-precentage-value,
            .power-bar-year-value{
              font-size:36px;
              line-height: 42px;
            }
        }
    }
  }
}

</style>


// WEBPACK FOOTER //
// CMSPowerBar.vue?452c34f0